/*
 *
 * HeylightFields
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 29-Jan-2025
 */

import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import '../ApmConfigurationModal.scss'
import PortalTextInput from '@nexidigital/portaltextinput'
import { messages } from '../languageModule'
import usePrevious from 'Hooks/usePrevious'
import { useIntl } from 'react-intl'

const HeylightFields = ({ formik, initialValue, loading, ...props }) => {
  const intl = useIntl()
  const prevStatus = usePrevious(formik.values.status)
  useEffect(() => {
    if (prevStatus === 'Disabled' && formik.values.status === 'Enabled' && !initialValue) {
      formik.setFieldTouched('merchantKey', true)
    }
  }, [formik.values.status, prevStatus, initialValue])

  return (
    <PortalTextInput
      ariaLabelIcon={intl.formatMessage(messages.warningAriaLabel)} 
      label={intl.formatMessage(messages.heylightFieldsMerchantKeyLabel)}
      id='heylightMerchantKey'
      type='text'
      onChange={(e) => formik.setFieldValue('merchantKey', e.target.value)}
      onFocus={() => {
        if (formik.values.merchantKey === initialValue) formik.setFieldValue('merchantKey', '')
      }}
      onBlur={(e) => {
        if (e.target.value === '') {
          formik.setFieldValue('merchantKey', initialValue || '')
          if (initialValue) {
            formik.setFieldTouched('merchantKey', false, false)
          } else {
            formik.setFieldTouched('merchantKey', true)
          }
        } else {
          formik.setFieldTouched('merchantKey', true)
        }
      }}
      error={!!(formik.touched.merchantKey && formik.errors.merchantKey)}
      errorText={formik.errors.merchantKey}
      value={formik.values.merchantKey}
      placeholder=' '
      disabled={loading || formik.values.status === 'Disabled'}
      {...props}
    />
  )
}

HeylightFields.propTypes = {
  /** formik object */
  formik: PropTypes.object.isRequired,
  initialValue: PropTypes.string.isRequired,
  loading: PropTypes.bool
}

HeylightFields.defaultProps = {
  formik: {},
  initialValue: '',
  loading: false
}

export default HeylightFields
